import { gen2Request } from 'src/services/gen_2_http_reqs';
import type { SettingRequest } from 'src/types/requests/settings/setting';

export const getAvailableNetworks = async (device) => {
	//this function can be used on gen2 network settings(it's absolutely the same). For now it is used only for Wi-Fi batch update inside WiFiCredentials component
	const res: SettingRequest = await gen2Request(device, 'WiFi.Scan', {}, false);
	let networksList = [];

	if (res.isok) {
		//@ts-ignore
		const results = res?.data?.results || res?.results || [],
			checkDuplicateList = [];
		results.forEach((network) => {
			if (checkDuplicateList.indexOf(network.ssid) == -1) {
				const icon = `fas fa-wifi${network.rssi < -67 ? (network.rssi < -80 ? '-weak' : '-fair') : ''}`;
				networksList.push({
					value: network.ssid,
					title: network.ssid + (network.auth == 0 ? ' (open)' : ' '),
					is_open: network.auth == 0,
					icon,
				});
			}
			checkDuplicateList.push(network.ssid);
		});
	}

	return networksList;
};
